export default {
    comentarios: '', 
    comentario:'',
    salesid:'',
    error: false,
    errorMessage: '',
    

  }